import moment from 'moment';
//import Config from "Config"
import sha256 from "js-sha256"
import queryString from "query-string"
import { dummyPartnerName } from "../../constant/constant"
import _ from 'lodash';
import React, { Component } from 'react';
import store from "../store/store";
//import * as braze from  "@braze/web-sdk";
import mixpanel from 'mixpanel-browser';
import { GetEnvVar } from "./AppConfig"


//Start of Analytics Logging //
const useMixpanel = true;

const analytic = useMixpanel ? mixpanel : amplitude;
if(useMixpanel){
  analytic.init(GetEnvVar('MIXPANEL_INFO'), {debug: GetEnvVar('NODE_ENV')  === "development" ? true: false});
}

export const setAmplitudeInit = (apikey) => {
  if(!useMixpanel){
    analytic.getInstance("avibra").init(apikey);
  }
}

export const setLogEvent = (log, payload) => {
 
  if(payload){
    if(useMixpanel){
      analytic.track(log, payload);
    }
    else{
      analytic.getInstance("avibra").logEvent(log, payload)
    }
  
  }
   else {
    if(useMixpanel){
      analytic.track(log);
    }
    else{
      analytic.getInstance("avibra").logEvent(log)
    }
  
  } 
}

export const setUserProperties = (data) => {
  if(useMixpanel){
    analytic.register_once(data);
  }
  else
    analytic.getInstance("avibra").setUserProperties(data)
}

export const setAmplitudeUserId = (id) =>{
  if(useMixpanel){
    if(!id)
      return;
    analytic.identify(id);
    mixpanel.people.set({ "Profile ID": id });
  }
  else
    analytic.getInstance("avibra").setUserId(id)
}
// End Of Analytics logging //


export const initBrazeSdk = () =>{
  //console.log("initBrazeSdk called ==>", GetEnvVar('BRAZE_API_KEY'), GetEnvVar('BRAZE_BASE_URL'));
  if(GetEnvVar('BRAZE_API_KEY') )
    braze.initialize(GetEnvVar('BRAZE_API_KEY'), {
      baseUrl: GetEnvVar('BRAZE_BASE_URL')
    });
}

export const convertValidDateTime = (date, format) => moment(date).format(format)

export const formatDollar = (num1 = 0) => {
    let num = parseInt(num1);
    if( num<=0 || num == null || num == '' ) return '0';
    var p = num.toFixed(2).split(".");
    return p[0].split("").reverse().reduce(function(acc, num, i, orig) {
        return  num=="-" ? acc : num + (i && !(i % 3) ? "," : "") + acc;
    }, "");
}


export const isEmpty = (obj) => {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}
export const Capitalize = (str)=>{
    var word  = str.toLowerCase();
    var firstLetter = word.slice(0,1);
    return firstLetter.toUpperCase() + word.substring(1);
}
export const keyValueArrayToObj = (array) => {
    return array.reduce((obj, item) => (obj[item.key] = item.value, obj) ,{});
}
export const InterpolateUrl = (string, values) => {
    try {

            let stringMatch = string.match(/[^{\}]+(?=})/g);
            if(stringMatch && values[stringMatch[0]])
                return string.replace(/{(.*?)}/g, (match, offset) => values[offset]);
            return false;
        } catch (error) {
            //console.log(error)
            return false
    }

};

export const isEmojis = input => {
  // emoji regex from the emoji-regex library
  var regex = /\uD83C\uDFF4(?:\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\u200D\u2620\uFE0F)|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])|(?:[#*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDD1-\uDDDD])/g
  return regex.test(input)
}

export const newInputValidator = (input, type, validation = null)=>{
  if(validation){

    try {

      let finalValidateExpression = validation.expression;
      validation.validations.map((validate,index)=>{
        switch (validate.type) {
         
          case 'expression':
            finalValidateExpression = finalValidateExpression.replace(`$${index}`, eval(validate.data));
            break;
          case 'regex':
              var re = new RegExp(validate.data);
              finalValidateExpression = finalValidateExpression.replace(`$${index}`, re.test(input));
            break
          default:
            break;
        }

      })
      return eval(finalValidateExpression)

    } catch (error) {
      //console.log(error);
      return input == "" ? false : true;
    }
  }
  else if( type.toLowerCase().indexOf('dob') !== -1 || type.toLowerCase().indexOf('date') !== -1 || type.toLowerCase().indexOf('year') !== -1){
    let inputType = type;
    let  maximumDate = null;
      let  minimumDate = null;
      let userdate = moment(input.replace(/\s/g,''),'MM/DD/YYYY', true);

      if(inputType == 'dob'){
          maximumDate = moment().add(-18, 'years').toDate();
          minimumDate = moment().add(-100, 'years').toDate();
      }else if(inputType == 'dependentdob'){
        maximumDate = moment().add(0, 'years').toDate();
        minimumDate = moment().add(-18, 'years').toDate();
      }
      else if(inputType == 'bendob' || inputType.toLowerCase() == 'productdob'){
        maximumDate = moment().add(0, 'years').toDate();
        minimumDate = moment().add(-100, 'years').toDate();
      }
      else if(type.toLowerCase().indexOf('year') !== -1){
        return moment(input.replace(/\s/g,''),'YYYY', true).isValid()
      }
      else{
        maximumDate = moment().add(50, 'years').toDate();
        minimumDate = moment().add(-50, 'years').toDate();
      }

      if (userdate.isValid() && !(userdate.isBefore(minimumDate) || userdate.isAfter(maximumDate)))
        return true;
      else
        return false;
  }
  else{
    let inputType = type.toLowerCase().indexOf('password')!= -1 ? 'password' : type;
    let validaterJson = store.getState().feparamsReducer.appConfig?.inputvalidator;
    let regJson = validaterJson ? JSON.parse(validaterJson) : {}
    switch(inputType){
      case 'botemaillabelprompt':
      case 'botemailprompt':
      case 'email':
      case 'workemail':
      case 'recipientemail':
      case 'dependentemail':

           var re = new RegExp(regJson.email) ///^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(input);
      case 'phone':
      case 'mobile':
      case 'contactnumber':
        var re = new RegExp(regJson.phone) ///^\d{10}$/;
        return re.test(input);
      case 'fullname':
      case 'name':
            //var re = /^(([A-Za-z]+[\-\']?)*([A-Za-z]+)?\s)+([A-Za-z]+[\-\']?)*([A-Za-z]+)?$/;
            var re = new RegExp(regJson.name) ///^\s*([A-Za-z]{2,}([\.,] |[-']| ))+[A-Za-z][a-z]+\.?\s*$/;
            return re.test(input);
      case 'password':
            //var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
            // var re = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/;
            var re = new RegExp(regJson.password) ///^(?=.*\d)(?=.*[-`~!@#$%^+=&*(),.?"';:{}|<>\\/[\]])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
            return !isEmojis(input) && re.test(input);
      case 'zipcode':
            var re = new RegExp(regJson.zipcode) ///^\d{5}$/;
            return re.test(input);
      case 'others':
            var re = new RegExp(regJson.others) ///^[a-zA-Z ]*$/;
            if(input.trim())
              return re.test(input);
            return false;
      case 'ssn':
            var re = new RegExp(regJson.ssn)///\d{9}/;
            if(input.trim())
              return re.test(input);
            return true;
      // case 'dob':
      // case 'date':
      // case 'bendob':
      // case 'productDOB':
      // case 'productdob':
  
      //       let  maximumDate = null;
      //       let  minimumDate = null;
      //       let userdate = moment(input.replace(/\s/g,''),'MM/DD/YYYY', true);
      //       if(inputType == 'dob'){
      //           maximumDate = moment().add(-18, 'years').toDate();
      //           minimumDate = moment().add(-100, 'years').toDate();
      //       }
      //       else if(inputType == 'bendob' || inputType.toLowerCase() == 'productdob'){
      //         maximumDate = moment().add(0, 'years').toDate();
      //         minimumDate = moment().add(-100, 'years').toDate();
      //       }
      //       else{
      //         maximumDate = moment().add(50, 'years').toDate();
      //         minimumDate = moment().add(-50, 'years').toDate();
      //       }
  
      //       if (userdate.isValid() && !(userdate.isBefore(minimumDate) || userdate.isAfter(maximumDate)))
      //         return true;
      //       else
      //         return false;
      case 'hyperlink':
  
          var email = new RegExp(regJson.email);
          hasEmail =  email.test(input);
          re = new RegExp(regJson.hyperlink, 'i'); ///(?:(?:https?):\/\/|\b(?:[a-z\d]+\.[a-zA-Z]{2,6}))(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))?/i;
          hasLink =  re.test(input) ;
          
          if(hasLink && !hasEmail){
            return true
          }
          return false;
      case 'desiredmonthlyprice':
          var re = new RegExp(regJson.desiredmonthlyprice) ///^\d+(\.\d{1,2})?$/;
          var monthlyPriceRegx = new RegExp(regJson.monthlyprice)
          var price = parseFloat((input).replace(monthlyPriceRegx, '$1'));
          return re.test(input) ? price >= 1 && price <= 99.99 : false;
      case 'firstname':
      case 'firstName':
        var re = new RegExp(regJson.firstname) ///^[A-Za-z]+([\ A-Za-z]+){1,30}$/;
        return re.test(input);
      case 'lastname':
      case 'lastName':
        var re = new RegExp(regJson.lastname) ///^[A-Za-z]+([\ A-Za-z]+){1,30}$/;
        return re.test(input);
      case 'percentage':
        var re = new RegExp(regJson.percentage || "^[1-9][0-9]?$|^100$")
        return re.test(input);
      case 'bankdetail':
        var re = new RegExp(regJson.bankdetail || "^[a-zA-Z]+[-]+[0-9]+$")
        return re.test(input);
      default:
        return input == "" ? false : true;
  
    }
  }

}
export const inputValidator = (input, type, validation = null, fieldtype)=>{
  console.log("inputValidator called",input,type,fieldtype, "====>", type.toLowerCase().indexOf('dob'))
    if(validation){
  
      try {
  
        let finalValidateExpression = validation.expression;
        validation.validations.map((validate,index)=>{
          switch (validate.type) {
           
            case 'expression':
              finalValidateExpression = finalValidateExpression.replace(`$${index}`, eval(validate.data));
              break;
            case 'regex':
                var re = new RegExp(validate.data);
                finalValidateExpression = finalValidateExpression.replace(`$${index}`, re.test(input));
              break
            default:
              break;
          }
  
        })
        return eval(finalValidateExpression) == true ? true : false;
  
      } catch (error) {
        //console.log(error);
        return input == "" ? false : true;
      }
    }
    else if(type == 'dob') {
      let inputType = type;
      let  maximumDate = null;
        let  minimumDate = null;
        let inputDate = moment(input).format("MM/DD/YYYY")
        let userdate = moment(inputDate,'MM/DD/YYYY', true);
        console.log("If userdate===>", input, userdate );
        if(inputType == 'dob'){
            maximumDate = moment().add(-18, 'years').toDate();
            minimumDate = moment().add(-100, 'years').toDate();
        }
        if (userdate.isValid() && !(userdate.isBefore(minimumDate) || userdate.isAfter(maximumDate)))
          return true;
        else
          return false;
    }
    else if(( type.toLowerCase().indexOf('dob') !== -1 || type.toLowerCase().indexOf('date') !== -1 || type.toLowerCase().indexOf('year') !== -1) && (fieldtype.toLowerCase().indexOf('botdate') !== -1)){
      let inputType = type;
        let  maximumDate = null;
        let  minimumDate = null;
        let userdate = moment(input.replace(/\s/g,''),'MM/DD/YYYY', true);
        
        if(inputType == 'dob'){
            maximumDate = moment().add(-18, 'years').toDate();
            minimumDate = moment().add(-100, 'years').toDate();
        }
        else if(inputType == 'bendob' || inputType.toLowerCase() == 'productdob'){
          maximumDate = moment().add(0, 'years').toDate();
          minimumDate = moment().add(-100, 'years').toDate();
        }
        else if(type.toLowerCase().indexOf('year') !== -1){
          return moment(input.replace(/\s/g,''),'YYYY', true).isValid()
        }
        else{
          maximumDate = moment().add(50, 'years').toDate();
          minimumDate = moment().add(-50, 'years').toDate();
        }
  
        if (userdate.isValid() && !(userdate.isBefore(minimumDate) || userdate.isAfter(maximumDate)))
          return true;
        else
          return false;
    }
    else{
      let inputType = type.toLowerCase().indexOf('password')!= -1 ? 'password' : type;
      switch(inputType){
        case 'botemaillabelprompt':
        case 'botemailprompt':
        case 'email':
        case 'workemail':
        case 'recipientemail':
              var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return re.test(input);
        case 'fullname':
        case 'name':
              //var re = /^(([A-Za-z]+[\-\']?)*([A-Za-z]+)?\s)+([A-Za-z]+[\-\']?)*([A-Za-z]+)?$/;
              var re =/^\s*([A-Za-z]{1,}([\.,] |[-']| ))+[A-Za-z]+\.?\s*$/;
              return re.test(input);
        case 'password':
              //var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
              var re = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/;
              return !isEmojis(input) && re.test(input);
        case 'zipcode':
              var re = /^\d{5}$/;
              return re.test(input);
        case 'contactnumber':
              var re = /^\d{10}$/;
              return re.test(input);
        case 'others':
              var re = /^[a-zA-Z ]*$/;
              if(input.trim())
                return re.test(input);
              return false;
        case 'ssn':
              var re = /\d{9}/;
              if(input.trim())
                return re.test(input);
              return true;
        case 'phone':
              var re = /\d{10}/;
              // if(input.trim())
                return re.test(input);
              return true;
        // case 'dob':
        // case 'date':
        // case 'bendob':
        // case 'productDOB':
        // case 'productdob':
    
        //       let  maximumDate = null;
        //       let  minimumDate = null;
        //       let userdate = moment(input.replace(/\s/g,''),'MM/DD/YYYY', true);
        //       if(inputType == 'dob'){
        //           maximumDate = moment().add(-18, 'years').toDate();
        //           minimumDate = moment().add(-100, 'years').toDate();
        //       }
        //       else if(inputType == 'bendob' || inputType.toLowerCase() == 'productdob'){
        //         maximumDate = moment().add(0, 'years').toDate();
        //         minimumDate = moment().add(-100, 'years').toDate();
        //       }
        //       else{
        //         maximumDate = moment().add(50, 'years').toDate();
        //         minimumDate = moment().add(-50, 'years').toDate();
        //       }
    
        //       if (userdate.isValid() && !(userdate.isBefore(minimumDate) || userdate.isAfter(maximumDate)))
        //         return true;
        //       else
        //         return false;
        case 'hyperlink':
    
            var email = /\S+@\S+\.\S+/;
            hasEmail =  email.test(input);
            re =/(?:(?:https?):\/\/|\b(?:[a-z\d]+\.[a-zA-Z]{2,6}))(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))?/i;
            hasLink =  re.test(input) ;
            
            if(hasLink && !hasEmail){
              return true
            }
            return false;
        case 'desiredmonthlyprice':
            var re = /^\d+(\.\d{1,2})?$/;
            var price = parseFloat((input).replace(/^(.*\.\d\d)\d*$/, '$1'));
            return re.test(input) ? price >= 1 && price <= 99.99 : false;
           
        default:
              return input == "" ? false : true;
    
      }
    }
  
  }

  export const selectOptionRefector = (options = []) =>{
    var refectoredOptions = [];
    options.map(option => {
         
        refectoredOptions.push({...option,...{value: option.id, label: option.value}}) 
    })
    return refectoredOptions;
}

export const HashValue = async (value = "") => {
  let hashValue = await sha256(value)

  return hashValue
}

export const getAge = dob => {
  let age = moment().diff(dob, "years", false);
  return age.toString()
}

export const formatContactNumber = (contactnumber) =>{
  let contactNumber = contactnumber.replace(/[^\d\+]/g,"");
  switch (contactNumber.length) {
    case 10:
      contactNumber = `+1${contactNumber}`;
      break;
    case 11:
      contactNumber = `+${contactNumber}`;
      break;
    default:
        break;
  }

  return contactNumber;
}

export const getPartnerName  = () => {
  let qsparam = queryString.parse(window.location.search.toLowerCase())

        let partnername = (
          qsparam["_partnerkey_"]
              ? qsparam["_partnerkey_"]
              : window.location.hostname.replace(".avibra.com","").toLowerCase()
        )
        
        if (GetEnvVar('NODE_ENV') === "development" && (partnername === "localhost" || partnername === "0.0.0.0")){
          partnername = "";//dummyPartnerName
        }

        return partnername
}

export const getPartnerCustomerID = (partnerid = "",externalid = "") => {
  if(externalid) { 
    return partnerid+":"+externalid
  } else {
    return partnerid
  }
}

export const  getErrorMessage = (err)=>{
  let errMsg =  "Unable to process your request. Please try after sometime.";
  //console.log(err.response);
  if(err.response){
    errMsg =  err.response.data &&  err.response.data.message ? err.response.data.message : errMsg; 
  }

  return errMsg;
}

export const  getUserPlans = (plans) => {
  let userPlans = [];
  plans.map(plan =>{
    userPlans.push(plan.split('_')[0])
  })
  return _.uniq(userPlans);
}

export const  filterByKeys = (obj={}, keys = [])  =>{
  const filtered = {}
  keys.forEach(key => {
    if (obj.hasOwnProperty(key)) {
      filtered[key] = obj[key]
    }
  })
  return filtered
}

export const sortPlans = (productList) => {
  Object.keys(productList).map(key=>{
    let product = productList[key];
      if(product.indexOf('$') !== -1){
        productList[key] = parseFloat(product.substring(
          product.lastIndexOf("$") + 1, 
          product.lastIndexOf("/")
        ));
      }
  });
  let sortedProductKeys = Object.keys(productList).sort(function(a,b){return productList[a]-productList[b]})
  return sortedProductKeys;
}
export const parsePlanMeta = (planDetails = {}) => {
  if(planDetails.feature)
    delete planDetails.feature
  Object.keys(planDetails).map(key=>{
    if(typeof planDetails[key] == 'string')
      planDetails[key] =  JSON.parse(unescape(planDetails[key]))
  })
  return planDetails;
}

export const customTextRender = (key, matchingString) => {
  // console.log(matchingString);
  // let pattern = /{(.*?)}/i;

  
  let match = matchingString;
  let types = match[1].split('|');
  let props = {}
  let style = {fontSize:18}
  let typesLength = types.length;
        switch (types[0]) {
            case 'bold':
                return  <span key={`${key}`} className={"bold-text"}>{types[typesLength - 1]}</span>
            case 'note':
                return  <span key={`${key}`} className={"note-text"}>{types[typesLength - 1]}</span>
            case 'link':
                return  <a  key={`${key}`} href={types[1]} target="_blank" className={"underline"} >{types[typesLength - 1]}</a>
            case 'signature':
              console.log(store.getState().lifeInsuranceReducer);
                const name = store.getState().lifeInsuranceReducer.lifeUserInfo ? store.getState().lifeInsuranceReducer.lifeUserInfo['Name'] : 'your name'
                return  <span  key={`${key}`} className={"signature"} >{name || 'your name'}</span>
            default:
                return  types[typesLength - 1]
                
        }
}

export const formatAddress = (address)=>{
    var addressString = Object.values(address).filter(function(x){
        return (x !== (undefined || null || ''));
    });
    return addressString.toString();
}

export const getViewport = ()=> {

  var viewPortWidth;
  var viewPortHeight;
 
  // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
  if (typeof window.innerWidth != 'undefined') {
    viewPortWidth = window.innerWidth,
    viewPortHeight = window.innerHeight
  }
 
 // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
  else if (typeof document.documentElement != 'undefined'
  && typeof document.documentElement.clientWidth !=
  'undefined' && document.documentElement.clientWidth != 0) {
     viewPortWidth = document.documentElement.clientWidth,
     viewPortHeight = document.documentElement.clientHeight
  }
 
  // older versions of IE
  else {
    viewPortWidth = document.getElementsByTagName('body')[0].clientWidth,
    viewPortHeight = document.getElementsByTagName('body')[0].clientHeight
  }
  return [viewPortWidth, viewPortHeight];
 }

 export const getImageUrl = (url ="")=>{
    let proxyUrl = "";//"https://api.allorigins.win/raw?url=";
    return `${proxyUrl}${url}`
 }

 export const initBranchSdk = ()=>{
  if(GetEnvVar('NODE_ENV') == "production")
      branch.init('key_live_jaSdCpnirF2dYRCnd08tjhifxCbs4YBd');
  else
    branch.init('key_test_opRpDdbbBrXcWTvpi62AAffesEir3Wuw');
}

export const isMobile = () => {
  
  if (sessionStorage.desktop) // desktop storage 
      return false;
  else if (localStorage.mobile) // mobile storage
      return true;

  // alternative
  var mobile = ['iphone','ipad','android','blackberry','nokia','opera mini','windows mobile','windows phone','iemobile']; 
  for (var i in mobile) if (navigator.userAgent.toLowerCase().indexOf(mobile[i].toLowerCase()) > 0) return true;

  // nothing found.. assume desktop
  return false;
}